/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventrequestsdescription2Inputs */

const en_eventrequestsdescription2 = /** @type {(inputs: Eventrequestsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People you accept are in and can check in to the Live Room. Declining stays quiet.`)
};

const de_eventrequestsdescription2 = /** @type {(inputs: Eventrequestsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wen du annimmst, ist dabei und kann im Live Room einchecken. Ablehnen bleibt still.`)
};

/**
* | output |
* | --- |
* | "People you accept are in and can check in to the Live Room. Declining stays quiet." |
*
* @param {Eventrequestsdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventrequestsdescription2 = /** @type {((inputs?: Eventrequestsdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventrequestsdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventrequestsdescription2(inputs)
	return de_eventrequestsdescription2(inputs)
});
export { eventrequestsdescription2 as "eventRequestsDescription" }